
import React, { useState } from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import SkillAssessmentQuestionnaire from './SkillAssessmentQuestionnaire';
import { AssessmentResult } from '@/types/skillAssessment';

interface SkillAssessmentDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onComplete: (result: AssessmentResult) => void;
}

const SkillAssessmentDialog: React.FC<SkillAssessmentDialogProps> = ({
  isOpen,
  onOpenChange,
  onComplete
}) => {
  const handleComplete = (result: AssessmentResult) => {
    onComplete(result);
    onOpenChange(false);
  };

  const handleCancel = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto p-0">
        <div className="p-4">
          <SkillAssessmentQuestionnaire
            onComplete={handleComplete}
            onCancel={handleCancel}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SkillAssessmentDialog;
